export let AbTestVariant;

(function (AbTestVariant) {
  AbTestVariant["Off"] = "off";
  AbTestVariant["On"] = "on";
  AbTestVariant["A"] = "a";
  AbTestVariant["B"] = "b";
  AbTestVariant["C"] = "c";
  AbTestVariant["D"] = "d";
})(AbTestVariant || (AbTestVariant = {}));